module.exports = __webpack_public_path__ + "static/media/news1.d6e987e6.png";